/* ============================================================
   Sons of Battery — Drop Culture Theme
   Ein Skript für alle Seiten. Läuft ohne Abhängigkeiten.
   ============================================================ */
(function () {
  'use strict';

  /* ── Mengenwähler (Produktseite, Warenkorb) ──────────────── */
  function initQty(scope) {
    (scope || document).querySelectorAll('.qty').forEach(function (box) {
      if (box.dataset.wired) return;
      box.dataset.wired = '1';
      var input = box.querySelector('input');
      box.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.dataset.step === '-1' ? -1 : 1;
          var min = parseInt(input.min, 10) || 0;
          var next = Math.max(min, (parseInt(input.value, 10) || 0) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ── Vorschlagssuche ─────────────────────────────────────── */
  function initSearch() {
    var panel = document.getElementById('sobSearch');
    var form  = document.querySelector('[data-search-form]');
    if (!panel || !form) return;

    var feld   = form.querySelector('[data-search-input]');
    var out    = form.querySelector('[data-search-out]');
    var oeffner = document.querySelector('[data-search-open]');
    var schliesser = form.querySelector('[data-search-close]');

    var waehrung = form.getAttribute('data-currency') || 'EUR';
    var preisFmt;
    try {
      preisFmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: waehrung });
    } catch (e) {
      preisFmt = { format: function (n) { return n.toFixed(2) + ' ' + waehrung; } };
    }

    var timer = null, laufend = null, letzte = '';

    function oeffnen() {
      panel.hidden = false;
      panel.classList.add('is-open');
      if (oeffner) oeffner.setAttribute('aria-expanded', 'true');
      feld.setAttribute('aria-expanded', 'true');
      feld.focus();
    }
    function schliessen() {
      panel.classList.remove('is-open');
      panel.hidden = true;
      if (oeffner) oeffner.setAttribute('aria-expanded', 'false');
      feld.setAttribute('aria-expanded', 'false');
    }

    if (oeffner) {
      oeffner.addEventListener('click', function (e) {
        e.preventDefault();
        panel.classList.contains('is-open') ? schliessen() : oeffnen();
      });
    }
    if (schliesser) schliesser.addEventListener('click', schliessen);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) schliessen();
    });
    document.addEventListener('click', function (e) {
      if (!panel.classList.contains('is-open')) return;
      if (panel.contains(e.target) || (oeffner && oeffner.contains(e.target))) return;
      schliessen();
    });

    function schuetzen(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function bild(p) {
      if (p.featured_image && p.featured_image.url) return p.featured_image.url;
      if (typeof p.image === 'string') return p.image;
      return '';
    }

    function zeichne(daten, frage) {
      var r = (daten.resources && daten.resources.results) || {};
      var prod = r.products || [], koll = r.collections || [], seiten = r.pages || [];
      var artikel = r.articles || [];

      if (!prod.length && !koll.length && !seiten.length && !artikel.length) {
        out.innerHTML = '<p class="sobsearch-empty">Nichts gefunden für „' +
          schuetzen(frage) + '“. Versuch es mit einem kürzeren Wort.</p>';
        return;
      }

      var links = '';
      if (prod.length) {
        links += '<div><p class="sobsearch-h">Produkte</p>';
        prod.forEach(function (p) {
          var q = bild(p);
          var preis = '';
          var zahl = parseFloat(p.price);
          if (!isNaN(zahl)) preis = preisFmt.format(zahl);
          links += '<a class="sobsearch-prod" role="option" href="' + schuetzen(p.url) + '">' +
            (q ? '<img src="' + schuetzen(q) + '" alt="" width="46" height="46" loading="lazy">'
               : '<img alt="" width="46" height="46">') +
            '<span class="t"><b>' + schuetzen(p.title) + '</b>' +
            '<span class="p">' + preis + '</span>' +
            (p.available ? '' : '<em>ausverkauft</em>') +
            '</span></a>';
        });
        links += '</div>';
      }

      var rechts = '';
      function liste(titel, eintraege) {
        if (!eintraege.length) return '';
        var s = '<p class="sobsearch-h">' + titel + '</p>';
        eintraege.forEach(function (x) {
          s += '<a class="sobsearch-link" role="option" href="' + schuetzen(x.url) + '">' +
               schuetzen(x.title) + '</a>';
        });
        return s;
      }
      rechts += liste('Kategorien', koll);
      rechts += liste('Seiten', seiten);
      rechts += liste('Magazin', artikel);

      out.innerHTML =
        '<div class="sobsearch-grid">' + links + '<div>' + rechts + '</div></div>' +
        '<a class="sobsearch-all" href="' + form.getAttribute('action') +
        '?q=' + encodeURIComponent(frage) + '&type=product">Alle Treffer für „' +
        schuetzen(frage) + '“ &rarr;</a>';
    }

    function suchen(frage) {
      if (laufend) laufend.abort && laufend.abort();
      var url = form.getAttribute('action').replace(/\/?$/, '') +
        '/suggest.json?q=' + encodeURIComponent(frage) +
        '&resources[type]=product,collection,page,article&resources[limit]=5';

      var ctrl = null;
      try { ctrl = new AbortController(); laufend = ctrl; } catch (e) {}

      fetch(url, { headers: { 'Accept': 'application/json' }, signal: ctrl && ctrl.signal })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (feld.value.trim() === frage) zeichne(j, frage); })
        .catch(function () { /* Abbruch oder Netzfehler — altes Ergebnis stehen lassen */ });
    }

    feld.addEventListener('input', function () {
      var frage = feld.value.trim();
      if (frage === letzte) return;
      letzte = frage;
      clearTimeout(timer);

      if (frage.length < 2) {
        out.innerHTML = '<p class="sobsearch-hint">Tipp mindestens zwei Zeichen</p>';
        return;
      }
      out.innerHTML = '<p class="sobsearch-busy">Suche …</p>';
      timer = setTimeout(function () { suchen(frage); }, 220);
    });

    /* Pfeiltasten durch die Vorschläge */
    feld.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var treffer = [].slice.call(out.querySelectorAll('[role="option"]'));
      if (!treffer.length) return;
      e.preventDefault();
      var i = treffer.indexOf(out.querySelector('.is-active'));
      treffer.forEach(function (t) { t.classList.remove('is-active'); });
      i = e.key === 'ArrowDown' ? i + 1 : i - 1;
      if (i < 0) i = treffer.length - 1;
      if (i >= treffer.length) i = 0;
      treffer[i].classList.add('is-active');
      treffer[i].scrollIntoView({ block: 'nearest' });
    });

    form.addEventListener('submit', function (e) {
      var aktiv = out.querySelector('.is-active');
      if (aktiv) { e.preventDefault(); window.location.href = aktiv.href; }
    });
  }

  /* ── Widerruf (Revoq) ────────────────────────────────────── */
  function initRevoq() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-revoq-open]');
      if (!link) return;
      /* Nur abfangen, wenn die App wirklich da ist. Sonst greift der
         normale Link auf #revoq-widerruf, den Revoq selbst auswertet. */
      var api = window.RevoqWithdrawal;
      if (api && typeof api.open === 'function') {
        e.preventDefault();
        api.open();
      }
    });
  }

  /* ── Hell / Dunkel ───────────────────────────────────────── */
  function initTheme() {
    var wurzel = document.documentElement;

    function setzen(modus, merken) {
      if (modus === 'light') wurzel.setAttribute('data-theme', 'light');
      else wurzel.removeAttribute('data-theme');
      document.querySelectorAll('[data-theme-toggle]').forEach(function (b) {
        b.setAttribute('aria-pressed', modus === 'light' ? 'true' : 'false');
      });
      if (merken) {
        try { localStorage.setItem('sob-theme', modus); } catch (e) {}
      }
    }

    /* Der Kopf im Layout hat den Modus schon gesetzt — Knopf nachziehen */
    setzen(wurzel.getAttribute('data-theme') === 'light' ? 'light' : 'dark', false);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-theme-toggle]');
      if (!btn) return;
      setzen(wurzel.getAttribute('data-theme') === 'light' ? 'dark' : 'light', true);
    });

    /* Dem Systemwechsel nur folgen, wenn der Startmodus auf
       "Nach Geräteeinstellung" steht und der Besucher nichts
       eigenes gewählt hat. Sonst würde ein fester Startmodus
       im laufenden Betrieb wieder überschrieben. */
    if (window.matchMedia && window.SOB_THEME_START === 'auto') {
      var mq = window.matchMedia('(prefers-color-scheme: light)');
      var hoeren = function (e) {
        var gewaehlt = null;
        try { gewaehlt = localStorage.getItem('sob-theme'); } catch (err) {}
        if (!gewaehlt) setzen(e.matches ? 'light' : 'dark', false);
      };
      if (mq.addEventListener) mq.addEventListener('change', hoeren);
      else if (mq.addListener) mq.addListener(hoeren);
    }
  }

  /* ── Produktgalerie ──────────────────────────────────────── */
  function initGallery() {
    var stage = document.querySelector('[data-stage] .stage-img');
    if (!stage) return;
    var thumbs = [].slice.call(document.querySelectorAll('[data-thumb]'));

    /* Das Bühnenbild wird mit srcset ausgeliefert. Nur src zu setzen
       bleibt wirkungslos — der Browser bedient sich weiter am srcset.
       Deshalb srcset und sizes vorher entfernen. */
    function setzeBild(src, alt) {
      if (!src) return;
      stage.removeAttribute('srcset');
      stage.removeAttribute('sizes');
      stage.src = src;
      if (alt != null) stage.alt = alt;
    }

    function markiere(id) {
      thumbs.forEach(function (t) {
        t.setAttribute('aria-selected', String(t.dataset.mediaId === String(id)));
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
        t.setAttribute('aria-selected', 'true');
        setzeBild(t.dataset.full, t.dataset.alt || '');
      });
    });

    /* Variantenwechsel springt auf das passende Bild — auch dann,
       wenn es in der Miniaturleiste gar nicht auftaucht. */
    document.addEventListener('sob:variant', function (e) {
      var v = e.detail;
      if (!v) return;
      if (v.media_src) {
        setzeBild(v.media_src, v.media_alt || '');
        markiere(v.media_id);
        return;
      }
      var match = document.querySelector('[data-thumb][data-media-id="' + v.media_id + '"]');
      if (match) match.click();
    });
  }

  /* ── Varianten auf der Produktseite ──────────────────────── */
  function initVariants() {
    var root = document.querySelector('[data-product-form]');
    if (!root) return;

    var dataEl = document.getElementById('sob-variants-' + root.dataset.productId);
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idInput   = root.querySelector('[data-variant-id]');
    var addBtn    = root.querySelector('[data-add]');
    var priceBox  = document.querySelector('[data-price-box]');
    var stockBox  = document.querySelector('[data-stock]');
    var skuBox    = document.querySelector('[data-sku]');

    /* Eine Optionsgruppe ist entweder eine Radio-Reihe (Kärtchen,
       Farbpunkte) oder eine Aufklappliste. Beides muss gelesen werden. */
    function gruppen() {
      return [].slice.call(root.querySelectorAll('[data-option-group]'));
    }

    function wertVon(g) {
      var sel = g.querySelector('select');
      if (sel) return sel.value;
      var checked = g.querySelector('input:checked');
      return checked ? checked.value : null;
    }

    function selectedOptions() {
      return gruppen().map(wertVon);
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], hit = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v.options[j] !== opts[j]) { hit = false; break; }
        }
        if (hit) return v;
      }
      return null;
    }

    /* Nicht kombinierbare Optionen ausgrauen — bei Aufklapplisten
       werden die Einträge deaktiviert statt der Felder. */
    function markUnavailable(opts) {
      gruppen().forEach(function (g, gi) {
        var sel = g.querySelector('select');
        if (sel) {
          [].slice.call(sel.options).forEach(function (o) {
            var probe = opts.slice();
            probe[gi] = o.value;
            o.disabled = !findVariant(probe);
          });
          return;
        }
        g.querySelectorAll('input').forEach(function (input) {
          var probe = opts.slice();
          probe[gi] = input.value;
          input.disabled = !findVariant(probe);
        });
      });
    }

    /* Bei Farbpunkten steht der gewählte Wert neben der Beschriftung */
    function beschriftung(opts) {
      gruppen().forEach(function (g, gi) {
        var ziel = root.querySelector('[data-opt-current="' + g.dataset.optionIndex + '"]');
        if (ziel) ziel.textContent = opts[gi] || '';
      });
    }

    /* Auswahlfelder auf eine Variante nachziehen */
    function syncAuswahl(v) {
      gruppen().forEach(function (g, gi) {
        var wert = v.options[gi];
        var sel = g.querySelector('select');
        if (sel) { sel.value = wert; return; }
        g.querySelectorAll('input').forEach(function (i) {
          if (i.value === wert) i.checked = true;
        });
      });
    }

    function update(e) {
      var opts = selectedOptions();
      var v = findVariant(opts);

      /* Gibt es die Kombination nicht, würde sonst die alte Variante
         aktiv bleiben, während oben schon die neue Auswahl steht — der
         Kunde sähe eine Größe und kaufte eine andere. Deshalb auf die
         nächste Variante ausweichen, die zur zuletzt geänderten Option
         passt, und die übrigen Felder nachziehen. */
      if (!v) {
        var gi = -1;
        if (e && e.target) {
          var g = e.target.closest('[data-option-group]');
          if (g) gi = gruppen().indexOf(g);
        }
        if (gi > -1) {
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].options[gi] === opts[gi] && variants[i].available) { v = variants[i]; break; }
          }
          if (!v) {
            for (var j = 0; j < variants.length; j++) {
              if (variants[j].options[gi] === opts[gi]) { v = variants[j]; break; }
            }
          }
        }
        if (!v) v = variants[0];
        syncAuswahl(v);
        opts = selectedOptions();
      }

      markUnavailable(opts);
      beschriftung(opts);
      if (!v) return;

      if (idInput) idInput.value = v.id;

      if (priceBox) {
        /* Preise kommen bereits fertig formatiert aus Liquid */
        var html = '<span>' + v.price_html + '</span>';
        if (v.compare_html) html += '<s>' + v.compare_html + '</s>';
        html += '<span class="tax">' + (priceBox.dataset.taxNote || '') + '</span>';
        priceBox.innerHTML = html;
      }

      if (stockBox) {
        var qty = Number(v.inventory_quantity || 0);
        var managed = !!v.inventory_management;
        var exactStock = stockBox.dataset.exactStock === 'true';
        var stockClass = 'stock stock--ok';
        var stockText = stockBox.dataset.inStock || 'Auf Lager';

        if (!v.available) {
          stockClass = 'stock stock--out';
          stockText = stockBox.dataset.outStock || 'Ausverkauft';
        } else if (exactStock && managed && qty > 5) {
          stockText = qty + ' ' + (stockBox.dataset.countSuffix || 'Stück auf Lager');
        } else if (exactStock && managed && qty > 0) {
          stockClass = 'stock stock--low';
          stockText = (stockBox.dataset.lowPrefix || 'Nur noch') + ' ' + qty + ' ' +
            (stockBox.dataset.countSuffix || 'Stück auf Lager');
        } else if (exactStock && managed) {
          stockClass = 'stock stock--low';
          stockText = stockBox.dataset.backorderStock || 'Bestellbar — wird nachproduziert';
        }

        stockBox.className = stockClass;
        stockBox.textContent = stockText;
      }

      if (skuBox) skuBox.textContent = v.sku || '';

      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available
          ? (addBtn.dataset.labelAdd || 'In den Warenkorb')
          : (addBtn.dataset.labelSold || 'Ausverkauft');
      }

      /* URL aktualisieren, damit der Link teilbar bleibt */
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }

      /* Wichtig für Options-Apps (Globo & Co.):
         Ein per JavaScript gesetztes input.value loest KEIN change-Ereignis
         aus. Ohne dieses Signal merken die Apps den Variantenwechsel nicht
         und blenden ihre Zusatzfelder weder ein noch aus. Deshalb hier
         von Hand melden — einmal am Feld selbst, einmal als uebliches
         Dokument-Ereignis. */
      if (idInput) {
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        idInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      document.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true,
        detail: { variant: v, sectionId: root.dataset.productId }
      }));
      document.dispatchEvent(new CustomEvent('sob:variant', { detail: v }));
    }

    /* Nur auf die Optionsfelder hoeren, nicht auf das versteckte
       id-Feld — sonst ruft sich update() endlos selbst auf. */

    root.querySelectorAll('[data-option-group] input, [data-option-group] select')
      .forEach(function (feld) { feld.addEventListener('change', update); });
    update();
  }

  /* ── Warenkorbzähler nachladen ───────────────────────────── */
  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () { /* still egal — Zähler bleibt wie er ist */ });
  }

  /* ── Kollektionsfilter ───────────────────────────────────── */
  function initFilters() {
    var form = document.querySelector('[data-filter-form]');

    /* Mobiler Umschalter */
    var toggle = document.querySelector('[data-filter-toggle]');
    var panel = document.querySelector('.facets');
    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var open = panel.classList.toggle('is-open');
        toggle.textContent = open
          ? (toggle.dataset.labelClose || 'Filter schließen')
          : (toggle.dataset.labelOpen || 'Filter');
      });
    }

    if (!form) return;

    var laeuft = false;

    /* Auswahl schickt das Formular direkt ab — Shopify filtert serverseitig */
    function abschicken() {
      if (laeuft) return;
      laeuft = true;

      /* Leere Preisfelder nicht mitschicken, sonst landet
         "filter.v.price.gte=" in der Adresse und Shopify filtert daneben.
         Abgeschaltete Felder werden nicht übertragen. */
      form.querySelectorAll('input[type=number]').forEach(function (i) {
        if (i.value === '') i.disabled = true;
      });

      /* Nicht angehakte Kästchen brauchen wir gar nicht erst */
      form.querySelectorAll('input[type=checkbox]').forEach(function (i) {
        if (!i.checked) i.disabled = true;
      });

      var grid = document.querySelector('[data-product-grid]');
      if (grid) grid.classList.add('is-loading');
      form.submit();
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type=checkbox], select, input[type=number]')) abschicken();
    });

    /* Enter im Preisfeld soll filtern, nicht die Seite neu laden */
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('input[type=number]')) {
        e.preventDefault();
        abschicken();
      }
    });
  }

  /* ── Suche auf der Kollektionsseite ──────────────────────── */
  function initCollectionSearch() {
    var form = document.querySelector('[data-coll-search]');
    var grid = document.querySelector('[data-product-grid]');
    if (!form || !grid) return;

    var feld   = form.querySelector('[data-coll-search-input]');
    var leer   = form.querySelector('[data-coll-search-clear]');
    var notiz  = document.querySelector('[data-coll-search-note]');
    var handle = form.getAttribute('data-handle');
    var gesamt = parseInt(form.getAttribute('data-total'), 10) || 0;
    var abText = form.getAttribute('data-label-from') || 'ab';

    var preisFmt;
    try {
      preisFmt = new Intl.NumberFormat('de-DE', {
        style: 'currency', currency: form.getAttribute('data-currency') || 'EUR'
      });
    } catch (e) {
      preisFmt = { format: function (n) { return n.toFixed(2) + ' €'; } };
    }

    /* Ursprüngliches Raster merken, damit es beim Leeren zurückkommt */
    var originalHTML = grid.innerHTML;
    var pager = document.querySelector('.pager');
    var alle = null;      /* alle Produkte der Kollektion, einmal geladen */
    var laden = null;     /* laufender Ladevorgang */
    var timer = null;

    function schuetzen(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    /* Komplette Kollektion holen — 250 je Seite, so lange bis leer */
    function ladeAlle() {
      if (alle) return Promise.resolve(alle);
      if (laden) return laden;

      var gesammelt = [];
      function seite(n) {
        return fetch('/collections/' + handle + '/products.json?limit=250&page=' + n,
                     { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var p = (j && j.products) || [];
            gesammelt = gesammelt.concat(p);
            /* Sicherheitsnetz gegen endloses Blättern */
            if (p.length === 250 && n < 8) return seite(n + 1);
            return gesammelt;
          });
      }

      laden = seite(1).then(function (p) {
        alle = p.map(function (x) {
          var preise = (x.variants || []).map(function (v) { return parseFloat(v.price); })
                        .filter(function (n) { return !isNaN(n); });
          return {
            titel: x.title,
            url: '/products/' + x.handle,
            bild: (x.images && x.images[0] && x.images[0].src) || '',
            vendor: x.vendor || '',
            min: preise.length ? Math.min.apply(null, preise) : null,
            max: preise.length ? Math.max.apply(null, preise) : null,
            frei: (x.variants || []).some(function (v) { return v.available; }),
            suchtext: [x.title, x.vendor, x.product_type, (x.tags || []).join(' ')]
                        .join(' ').toLowerCase()
          };
        });
        return alle;
      }).catch(function () { alle = null; laden = null; return null; });

      return laden;
    }

    function karte(p) {
      var preis = '';
      if (p.min != null) {
        preis = (p.max > p.min ? abText + ' ' : '') + preisFmt.format(p.min);
      }
      return '<div class="pcard">' +
        '<a class="pcard-ph" href="' + schuetzen(p.url) + '" aria-label="' + schuetzen(p.titel) + '">' +
          (p.frei ? '' : '<div class="pcard-flags"><span class="flag flag--out">Ausverkauft</span></div>') +
          (p.bild ? '<img class="pcard-img" src="' + schuetzen(p.bild) + '" alt="" loading="lazy">'
                  : '<div class="pcard-empty"><span>SoB</span></div>') +
        '</a>' +
        '<a class="pcard-body" href="' + schuetzen(p.url) + '">' +
          '<div class="pcard-title">' + schuetzen(p.titel) + '</div>' +
          '<div class="price"><span class="price-item">' + preis + '</span></div>' +
        '</a></div>';
    }

    function zuruecksetzen() {
      grid.innerHTML = originalHTML;
      if (pager) pager.hidden = false;
      if (notiz) notiz.hidden = true;
      if (leer) leer.hidden = true;
    }

    function zeigen(q) {
      var treffer = alle.filter(function (p) { return p.suchtext.indexOf(q) > -1; });

      if (pager) pager.hidden = true;
      if (notiz) notiz.hidden = false;

      if (!treffer.length) {
        grid.innerHTML = '';
        if (notiz) {
          notiz.innerHTML = 'Kein Treffer in dieser Kategorie. ' +
            '<a href="' + form.getAttribute('action') + '?q=' + encodeURIComponent(q) +
            '&type=product">Im ganzen Shop suchen &rarr;</a>';
        }
        return;
      }

      grid.innerHTML = treffer.map(karte).join('');
      if (notiz) {
        /* Der Ausweg in die Shop-Suche bleibt immer sichtbar — sonst
           drückt jemand Enter und wundert sich, dass nichts passiert. */
        notiz.innerHTML = treffer.length + ' von ' + alle.length +
          ' Produkten dieser Kategorie &middot; ' +
          '<a href="' + form.getAttribute('action') + '?q=' + encodeURIComponent(q) +
          '&type=product">im ganzen Shop suchen &rarr;</a>';
      }
    }

    function anwenden() {
      var q = feld.value.trim().toLowerCase();
      if (leer) leer.hidden = q.length === 0;

      if (q.length < 2) { zuruecksetzen(); return; }

      if (notiz) { notiz.hidden = false; notiz.textContent = 'Suche …'; }

      ladeAlle().then(function (p) {
        if (feld.value.trim().toLowerCase() !== q) return;
        if (!p) {
          /* Kollektion nicht ladbar — dann wenigstens ehrlich weiterleiten */
          if (notiz) {
            notiz.innerHTML = 'Suche gerade nicht möglich. ' +
              '<a href="' + form.getAttribute('action') + '?q=' + encodeURIComponent(q) +
              '&type=product">Im ganzen Shop suchen &rarr;</a>';
          }
          return;
        }
        zeigen(q);
      });
    }

    feld.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(anwenden, 180);
    });

    if (leer) {
      leer.addEventListener('click', function () {
        feld.value = '';
        clearTimeout(timer);
        zuruecksetzen();
        feld.focus();
      });
    }

    /* Enter soll die Kategoriesuche nutzen, nicht wegspringen */
    form.addEventListener('submit', function (e) {
      if (feld.value.trim().length >= 2 && alle) { e.preventDefault(); }
    });
  }

  /* ── Sortierung ──────────────────────────────────────────── */
  function initSort() {
    var sel = document.querySelector('[data-sort]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ── Warenkorbzeilen: Menge ändern schickt ab ────────────── */
  function initCart() {
    var wrap = document.querySelector('[data-cart-form-wrap]');
    if (!wrap) return;

    /* Das Formular umschließt den Wrapper — nicht umgekehrt. */
    var form = document.getElementById('sob-cart-form') || wrap.closest('form');
    if (!form) return;

    var laeuft = false;

    function abschicken() {
      if (laeuft) return;
      laeuft = true;
      wrap.classList.add('is-loading');
      form.submit();
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('.qty input')) abschicken();
    });

    /* Enter im Mengenfeld soll nicht zur Kasse springen */
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('.qty input')) {
        e.preventDefault();
        abschicken();
      }
    });
  }

  /* Misst die Kopfleiste und legt ihre Höhe als --kopf-h ab. Alles, was
     unter dem Menü kleben soll (Filter, Kaufbox, Warenkorb-Summe, die
     Sprungleiste im Media-Kit), rechnet damit — statt mit einem fest
     eingetragenen Wert, der bei jeder Änderung am Menü falsch wird. */
  function initKopf() {
    var kopf = document.getElementById('shopify-section-header')
            || document.querySelector('.sobnav');
    if (!kopf) return;

    function messen() {
      var h = Math.round(kopf.getBoundingClientRect().height);
      if (h > 0) document.documentElement.style.setProperty('--kopf-h', h + 'px');
    }

    messen();
    window.addEventListener('resize', messen, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(messen).observe(kopf);
    /* Schriften kommen nachgeladen — danach ist die Leiste oft anders hoch. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(messen);
  }

  function init() {
    initKopf();
    initTheme();
    initSearch();
    initRevoq();
    initQty(document);
    initGallery();
    initVariants();
    initFilters();
    initCollectionSearch();
    initSort();
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify Theme-Editor: Sections werden neu geladen */
  document.addEventListener('shopify:section:load', init);
})();
